import styled from "@emotion/styled";
import { Text } from "./Typography";

const Error = styled(Text)(
  {
    fontWeight: "bold",
    fontStyle: "italic",
  },
  ({ theme }) => ({
    color: theme.colors.primary,
    marginLeft: theme.spacing.md,
  })
);

export { Error };
